export { default } from "./TranslationSetting";
